import React, { forwardRef, useEffect } from 'react';

import styles from './CustomCheckbox.module.scss';

export const Checkbox = forwardRef(({ indeterminate, ...rest }, ref) => {
  const defaultRef = React.useRef();
  const resolvedRef = ref || defaultRef;

  useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);

  return (
    <div className={styles.customCheckBox}>
      <input type="checkbox" ref={resolvedRef} {...rest} />
    </div>
  );
});
